import React from 'react';

export default function RecentTransactionTable({ columns, row, style = {} }) {
	return (
		<div
			className="table-container"
			style={style}
		>
			<table className="custom-table">
				<thead>
					<tr>
						{columns.map((m, idx) => (
							<th
								className={'cursor-pointer'}
								key={`${idx}`}
							>
								<div className="fs-5 fw-bold d-flex justify-content-start align-items-center gap-4">
									{m.label}
								</div>
							</th>
						))}
					</tr>
				</thead>

				<tbody>
					{row &&
						row.length > 0 &&
						row.map((rowItem, i) => (
							<tr key={i}>
								{columns.map((m, idx) => {
									return (
										<td
											key={`${i}-${idx}`}
											className="fs-5 fw-light"
										>
											{rowItem[m.key] || '-'}
										</td>
									);
								})}
							</tr>
						))}
				</tbody>
			</table>
		</div>
	);
}
